export enum NotificationType {
    SUCCESS = 'notification-success',
    INFO = 'notification-info',
    ERROR = 'notification-danger'
}